// extracted by mini-css-extract-plugin
export default {"fullwidth":"h0ZvxpDl","_hasBranding":"ZA01dXhg"};